export const TransactionStatus = {
    COMPLETE:"تکمیل",
    CANCEL:"لغو",
    REQUEST:"درخواست",
    PAYMENT_COMPLETE:"پرداخت شده",
    PAYMENT_REJECTED:"پرداخت رد شد",
}
